<template>
  <div>
    <b-card
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      class="full-width"
    >
      <v-dialog v-model="loading" fullscreen full-width>
        <v-container
          fluid
          fill-height
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
      <div slot="header">
        <strong style="font-size: 20px">Edit Office</strong>
        <b-button variant="primary" style="float: right" @click="done()">
          Back
        </b-button>
      </div>
      <div>
        <h3 style="color: #2c8ef8; margin-bottom: 20px">Office</h3>
        <b-row>
          <b-col md="3">
            <eb-select
              type="text"
              label="label"
              placeholder="Select Category"
              v-model="office.officeType"
              :options="officeOptions"
              :selected="office.officeType"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <slot name="name">
              <c-input
                inputType="text"
                inputId="userName"
                lableText="Office Name"
                v-model="office.officeName"
              />
            </slot>
          </b-col>
          <b-col md="4">
            <b-row v-for="(p, idx) in office.phone" :key="p + `${idx}`">
              <b-col md="9" class="pr-0">
                <c-tel-input
                  v-model="p.number"
                  @validate="(e) => isValidate(e, p)"
                  class=""
                  :defaultInput="p.number"
                />
              </b-col>
              <b-col md="2" class="pl-0">
                <b-button
                  btn-special="primary"
                  size="lg"
                  @click="onClickPhoneButton(p, idx)"
                >
                  <i class="fa fa-plus-circle mr-1"></i>
                  {{ p.text }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- //////////////// -->
        <b-row>
          <b-col md="3">
            <eb-select
              label="name"
              @input="getCountry"
              :options="countries"
              placeholder="Country"
              :selected="office.address.country"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <eb-select
              label="name"
              @input="getState"
              :options="states"
              placeholder="State"
              :selected="office.address.state"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <b-row v-for="(e, idx) in office.email" :key="idx">
              <b-col md="9" class="pr-0">
                <c-input
                  inputType="text"
                  inputId="email"
                  lableText="Email"
                  v-model="e.mailId"
                />
              </b-col>
              <b-col md="3" class="pl-0">
                <b-button
                  btn-special="primary"
                  size="lg"
                  @click="onClickEamilButton(e, idx)"
                >
                  <i class="fa fa-plus-circle mr-1"></i>
                  {{ e.text }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- //////////// -->
        <b-row>
          <b-col md="3">
            <eb-select
              placeholder="City"
              :options="cities"
              label="name"
              @input="getCity"
              :selected="office.address.city"
            ></eb-select>
          </b-col>
        </b-row>
        <!-- ///////////// -->
        <b-row>
          <b-col md="4">
            <c-input
              type="text"
              inputId="zipcode"
              v-model="office.address.zip"
              lableText="Zipcode"
            />
          </b-col>
        </b-row>
      </div>
      <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
      <hr style="border-top: 1px solid var(--primary)" class="mt-4" />
      <!-- //////////////////////////////////////////////////////////////////////////////// -->
      <div>
        <h3 style="color: #2c8ef8; margin-bottom: 20px">Organization</h3>
        <b-row class="mt-3">
          <b-col class="ml-4" md="6">
            <b-row>
              <b-col md="10">
                <c-input-form
                  inputType="text"
                  inputId="OrganizationName"
                  lableText="Organization Name"
                  v-model="organization.name"
                  class="mt-0"
                />
              </b-col>
            </b-row>
          </b-col>
          <!-- //////////// -->
          <b-col md="5">
            <GmapMap
              :center="position"
              :zoom="7"
              map-type-id="terrain"
              style="width: 440px; height: 441px"
            >
              <GmapMarker label="★" :draggable="true" :position="position" />
            </GmapMap>
          </b-col>
        </b-row>
      </div>
      <!-- ///////////////////////////////////////////// -->
      <hr style="border-top: 1px solid var(--primary)" class="mt-3" />
      <!-- /////////////////////////////////////////////////////////////////////////// -->
      <div class="mt-4">
        <h3 style="color: #2c8ef8; margin-bottom: 20px">Bill To</h3>
        <b-row>
          <b-col md="3">
            <eb-select
              type="text"
              label="label"
              placeholder="Select Category"
              v-model="billTo.officeType"
              :options="officeOptions"
              :selected="billTo.officeType"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <slot name="name">
              <c-input
                inputType="text"
                inputId="userName"
                lableText="Office Name"
                v-model="billTo.officeName"
              />
            </slot>
          </b-col>
          <b-col md="4">
            <b-row v-for="(p, idx) in billTo.phone" :key="p + `${idx}`">
              <b-col md="9" class="pr-0">
                <c-tel-input
                  v-model="p.number"
                  @validate="(e) => isValidate(e, p)"
                  :defaultInput="p.number"
                  class="m-0"
                />
              </b-col>
              <b-col md="2" class="pl-0">
                <b-button
                  btn-special="primary"
                  size="lg"
                  @click="onClickPhoneButtonBill(p, idx)"
                >
                  <i class="fa fa-plus-circle mr-1"></i>
                  {{ p.text }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- //////////////// -->
        <b-row>
          <b-col md="3">
            <eb-select
              label="name"
              @input="getCountryBill"
              :options="countries"
              placeholder="Country"
              :selected="billTo.address.country"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <eb-select
              label="name"
              @input="getStateBill"
              :options="states"
              placeholder="State"
              :selected="billTo.address.state"
            ></eb-select>
          </b-col>
          <b-col md="4">
            <b-row v-for="(e, idx) in billTo.email" :key="idx">
              <b-col md="9" class="pr-0">
                <c-input
                  inputType="text"
                  inputId="email"
                  lableText="Email"
                  v-model="e.mailId"
                />
              </b-col>
              <b-col md="3" class="pl-0">
                <b-button
                  btn-special="primary"
                  size="lg"
                  @click="onClickEamilButtonBill(e, idx)"
                >
                  <i class="fa fa-plus-circle mr-1"></i>
                  {{ e.text }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- //////////// -->
        <b-row>
          <b-col md="3">
            <eb-select
              placeholder="City"
              :options="cities"
              label="name"
              @input="getCityBill"
              :selected="billTo.address.city"
            ></eb-select>
          </b-col>
        </b-row>
        <!-- ///////////// -->
        <b-row>
          <b-col md="4">
            <c-input
              type="text"
              inputId="zipcode"
              v-model="billTo.address.zip"
              lableText="Zipcode"
            />
          </b-col>
        </b-row>
      </div>
      <!-- ////////////////////////////////////////////////////////////////////////////// -->
      <hr style="border-top: 1px solid var(--primary)" class="mt-4" />
      <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
      <div>
        <h3 style="color: #2c8ef8; margin-bottom: 20px">Authentication</h3>
        <b-row>
          <b-col md="4">
            <c-tel-input
              v-model="authentication.phone"
              :defaultInput="authentication.phone"
              class="m-0"
            />
          </b-col>
          <b-col md="4">
            <c-input
              inputType="text"
              inputId="username"
              lableText="User Name"
              v-model="authentication.userName"
            />
          </b-col>
          <b-col md="4"
            ><c-input
              inputType="text"
              inputId="email"
              lableText="Email"
              v-model="authentication.email"
            />
          </b-col>
        </b-row>
        <!-- ///// -->
        <b-row>
          <b-col md="4">
            <eb-select
              :label="'text'"
              placeholder="Security Question"
              :options="securityQuestions"
              :v-model="
                (authentication &&
                  authentication.securityQuestions &&
                  authentication.securityQuestions.question) ||
                ''
              "
              :selected="
                (authentication &&
                  authentication.securityQuestions &&
                  authentication.securityQuestions.question) ||
                ''
              "
            ></eb-select>
          </b-col>
          <b-col md="4">
            <c-input
              inputType="text"
              inputId="sqa"
              lableText="Security Question Answers"
              :v-model="
                (authentication &&
                  authentication.securityQuestions &&
                  authentication.securityQuestions.answer) ||
                ''
              "
            />
          </b-col>
        </b-row>
      </div>
      <div class="text-center mb-5 mt-5">
        <button
          type="button"
          class="btn btn-lg btn-outline-success ml-3 w-25"
          @click.prevent="submitAllData"
        >
          Update
        </button>
      </div>
    </b-card>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import cInputForm from "@/components/FormElements/CustomInput";
import { getReverseGeoCode } from "@/services/geocode";
import Vue from "vue";
export default {
  name: "EditOffice",

  data() {
    return {
      loading: false,
      billTo: {
        officeType: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
          },
        ],

        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
            isValid: false,
          },
        ],
        address: {
          country: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          location: {},
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
      securityQuestions: [
        {
          text: "what is your mother maiden name",
          value: "what is your mother maiden name",
        },
        {
          text: "what is your first school",
          value: "what is your first school",
        },
        { text: "your first car model", value: "your first car model" },
      ],
      authentication: {
        phone: "",
        email: "",
        userName: "",
        password: "",
        securityQuestions: {
          question: {},
          answer: "",
        },
      },
      organization: {
        name: "",
        logo: "",
        orgAccessLevel: "",
        orgAccessList: null,
      },
      position: {
        lat: 0,
        lng: 0,
      },
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        officeType: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
          },
        ],

        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
            isValid: false,
          },
        ],
        address: {
          country: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          location: {},
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
    cInputForm,
  },
  computed: {
    orgAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Limited",
          value: "Limited",
        },
      ];
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category === "OFFICE") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              password: "",
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
    officeOptions() {
      return [
        {
          label: "Default",
          value: "DEFAULT",
        },
        {
          label: "Head Office",
          value: "HEAD_OFFICE",
        },
        {
          label: "Regional Office",
          value: "REGIONAL_OFFICE",
        },
        {
          label: "Branch Office",
          value: "BRANCH_OFFICE",
        },
      ];
    },
  },
  methods: {
    done() {
      this.$router.push("/office-management");
    },
    async submitAllData() {
      try {
        const data = await getReverseGeoCode(
          `${this.office.address.street1},${this.office.address.city},${this.office.address.state},${this.office.address.country}`
        );
        if (data.data.status === "OK") {
          this.office.address.location = {
            coordinates: [
              data.data.results[0].geometry.location.lat,
              data.data.results[0].geometry.location.lng,
            ],
          };
        }
      } catch (error) {}

      //////////////////////////////////////////////////////////
      try {
        const dataBill = await getReverseGeoCode(
          `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`
        );
        if (dataBill.data.status === "OK") {
          this.billTo.address.location = {
            coordinates: [
              dataBill.data.results[0].geometry.location.lat,
              dataBill.data.results[0].geometry.location.lng,
            ],
          };
        }
      } catch (error) {}
      ////////////////////////////////////////////////////////////////////////////////
      const { organization, billTo, office, authentication } = this;
      const authenticationCopy = { ...authentication };
      authenticationCopy.securityQuestions = {
        question: authentication.securityQuestions?.question,
        answer: authentication.securityQuestions?.answer,
      };
      const tenant = this.$store.getters["auth/getUserID"];
      office.officeType = this.office.officeType?.value;
      //delete authenticationCopy.securityQA;
      delete organization.location;
      delete authenticationCopy.password;
      delete organization.orgAccessLevel;
      delete organization.orgAccessList;
      delete organization.state;
      const payload = {
        id: this.$store.getters["partner/GetPartnerData"]._id,
        data: {
          authentication: authenticationCopy,
          billTo,
          office,
          organization,
          tenant,
          agreement: {
            doc: "test",
          },
          category: "OFFICE",
        },
      };
      this.loading = true;
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.loading = false;
          this.$swal({
            title: "Success",
            text: "Office Edited successfully!",
            type: "success",
          });
          this.$router.push("/office-management");
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "Could not Edit office",
            type: "error",
          });
        });
      //////////////////////////////////////////////////////////////////////////////
    },
    async onClickPhoneButtonBill(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.billTo.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.billTo.phone.splice(idx, 1);
    },
    async onClickEamilButtonBill(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.billTo.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.billTo.email.splice(idx, 1);
    },
    getCountryBill(payload) {
      this.setState(payload.id);
      this.billTo.address.country = payload.name;
    },
    getStateBill(payload) {
      this.setCity(payload.id);
      this.billTo.address.state = payload.name;
    },
    getCityBill(payload) {
      this.billTo.address.city = payload.name;
    },
    async setPlace(p) {
      let place = await p;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
    },
    readLogo(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadImage(reader.result);
      };
      reader.onerror = (err) => {};
    },
    // upload images to the S3 bucket
    async uploadImage(image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.organization.logo = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    changeLevel(event) {
      if (event.value === "Global") {
        this.organization.orgAccessList = null;
      }
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    getState(payload) {
      this.setCity(payload.id);
      this.office.address.state = payload.name;
    },
    getCity(payload) {
      this.office.address.city = payload.name;
    },
    async setCountry() {
      this.countries = await csc.getAllCountries();
    },
    async setState(id) {
      this.states = await csc.getStatesOfCountry(id);
    },
    async setCity(id) {
      this.cities = await csc.getCitiesOfState(id);
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "minus",
        });
      else this.office.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "minus",
        });
      else this.office.phone.splice(idx, 1);
    },
  },
  mounted() {
    this.setCountry();
    // this.$store.dispatch("partner/fetchPartnersList");
    this.office = this.$store.getters["partner/GetPartnerData"].office;
    this.organization =
      this.$store.getters["partner/GetPartnerData"].organization;
    this.billTo = this.$store.getters["partner/GetPartnerData"].office;

    this.authentication.phone =
      this.$store.getters["partner/GetPartnerData"].authentication.phone;
    this.authentication.email =
      this.$store.getters["partner/GetPartnerData"].authentication.email;
    this.authentication.userName =
      this.$store.getters["partner/GetPartnerData"].authentication.userName;
    this.authentication.securityQuestions =
      this.$store.getters[
        "partner/GetPartnerData"
      ].authentication.securityQuestions;
    this.authentication.password =
      this.$store.getters["partner/GetPartnerData"].authentication.password;

    this.position.lat =
      this.$store.getters[
        "partner/GetPartnerData"
      ].office.address.location.coordinates[1];
    this.position.lng =
      this.$store.getters[
        "partner/GetPartnerData"
      ].office.address.location.coordinates[0];
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: var(--primary);
  color: white;
}
[btn-special="primary1"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #2433d7;
  color: white;
}
.back-btn {
  font-weight: bold;
  float: right;
}
.back-btn:hover {
  background-color: #24a07d;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}

.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}

.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
.sqanswer {
  margin-top: -12px !important;
}
.footer-bottons-class {
  margin-top: 50px;
  text-align: center;
  margin-left: 40%;
}
</style>
